import { RequestDataSetting, updateSettingChat } from 'api/chat/setting/update-setting';
import { useSubscription } from 'hooks/use-subscription.hook';
import React, { useEffect, useState } from 'react';
import { IconProfile } from '../list-sidebar';

interface IMessageProps {
  self: RequestDataSetting;
}
function Profile({ self }: IMessageProps) {
  const subscription = useSubscription();
  const [statusActive, setStatusActive] = useState({
    is_profile_tagging: self.is_profile_tagging,
    isCheckChangeContent: false,
  });

  useEffect(() => {
    if (!statusActive.isCheckChangeContent) return;

    const chatSettingSub = updateSettingChat(self._id, {
      is_profile_tagging: statusActive.is_profile_tagging,
    }).subscribe();

    subscription.add(chatSettingSub);
  }, [statusActive, subscription, self._id]);

  return (
    <div className='profile'>
      <div className='profile-block'>
        <div className='profile-item'>
          <img src={IconProfile} alt='anh' />
        </div>
        <div className='profile-item-text'>Your profile</div>
      </div>

      <div className='tab-item'>
        <li className='list-group-item'>
          Allow others to tag you
          <label className='switch '>
            <input
              type='checkbox'
              checked={statusActive.is_profile_tagging}
              onChange={() =>
                setStatusActive({ is_profile_tagging: !statusActive.is_profile_tagging, isCheckChangeContent: true })
              }
              className='success'
            />
            <span className='slider round'></span>
          </label>
        </li>
      </div>
    </div>
  );
}

export default Profile;
